import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { numericality, required } from 'redux-form-validators';
import { FormattedMessage } from 'react-intl';
import { ReduxTextField, DefaultButton } from 'common/components';
import { putTarget } from 'common/dashboards/_redux';

import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const TargetForm = ({
  handleSubmit,
  pristine,
  submitting,
  invalid,
  error,
  theme,
  dispatch,
  lastMonthUsers,
  lastMonthRealUsers,
  lastMonthFtd,
  partnerId,
  sampleType,
  isClientInterface,
}) => {
  const submit = handleSubmit(values =>
    putTarget({ target: values, partnerId, sampleType, isClientInterface }, dispatch)
  );
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const TargetData = [
    {
      name: 'users',
      title: 'boRegistered',
      lastMonthValue: lastMonthUsers,
    },
    {
      name: 'realUsers',
      title: 'boOpenedLiveAccount',
      lastMonthValue: lastMonthRealUsers,
    },
    {
      name: 'depositedUsers',
      title: 'boFTD',
      lastMonthValue: lastMonthFtd,
    },
  ];
  return (
    <form className="TargetForm" onSubmit={submit}>
      <FormattedMessage id="boTargetDescription">
        {txt => <span className="TargetForm__description">{txt}</span>}
      </FormattedMessage>
      {TargetData.map(item => (
        <div className="TargetForm__row" key={item.name}>
          <div className="TargetForm__input">
            <FormattedMessage id={item.title}>
              {txt => <span className="TargetForm__input-description">{txt}</span>}
            </FormattedMessage>
            <Field
              component={ReduxTextField}
              autoComplete="off"
              type="text"
              name={item.name}
              textId="justTarget"
              validate={[required(), numericality({ int: true, '>': 0, '<=': 100000000 })]}
              disabled={submitting}
            />
          </div>
          <div className="TargetForm__last-month">
            <FormattedMessage id="lastMonth">{txt => <span>{txt}</span>}</FormattedMessage>
            <span>{item.lastMonthValue}</span>
          </div>
        </div>
      ))}
      <DefaultButton
        textId="justSave"
        type="submit"
        loading={submitting}
        disabled={invalid || pristine || submitting}
        filled
      />
      {error && <strong>{error}</strong>}
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </form>
  );
};

TargetForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  theme: PropTypes.object,
  lastMonthUsers: PropTypes.number,
  lastMonthRealUsers: PropTypes.number,
  lastMonthFtd: PropTypes.number,
  partnerId: PropTypes.number.isRequired,
  sampleType: PropTypes.string.isRequired,
  isClientInterface: PropTypes.bool,
};

TargetForm.defaultProps = {
  error: '',
  theme: {},
  lastMonthUsers: 100,
  lastMonthRealUsers: 50,
  lastMonthFtd: 10,
  isClientInterface: false,
};

export default compose(
  withTheme(),
  reduxForm({
    form: 'targetForm',
    onSubmitSuccess(result, dispatch, props) {
      props.closeModal();
    },
  })
)(TargetForm);
export { TargetForm };
